module Lockable
{
	const unlockAttributeName = "unlock";

	export function construct()
	{
		$(`[data-${unlockAttributeName}]`).click((event) => {
			const element = $(event.target);
			element.addClass("disabled");

			const lockedElement = $(element.data(unlockAttributeName));
			const readonlyChildren = lockedElement.find("[readonly]:not(.permalocked)");
			readonlyChildren.prop("readonly", false);
			readonlyChildren.removeAttr("readonly");
		});
	}
}